import { jsxs as r, jsx as l } from "react/jsx-runtime";
const t = (c) => /* @__PURE__ */ r(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...c,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m36.92 43.2 4.07-4.07c1.35-1.35 1.25-3.28-.12-4.65l-1.71 1.51c.55.55.51 1.29 0 1.8l-1.6 1.6c.18-.91-.2-1.71-.77-2.28-.07-.07-.15-.15-.23-.21l1.72-1.72-1.34-1.34-2.14 2.14c-.44-.2-.8-.39-1.17-.76-.65-.65-.5-1.4-.01-1.89.63-.63 1.4-.55 2.16.18l1.17-2.02c-1.06-.94-2.99-1.52-4.86.35-1.71 1.71-1.47 3.89-.28 5.08.4.4.79.67 1.18.86l-.7.7 1.34 1.34 1.18-1.18c.16.11.32.22.45.35.72.72.72 1.72.22 2.75l1.44 1.46Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M38.08 51.6 14.5 28.02l1.96-8.73 3.62 3.62c-.35.76-.55 1.6-.55 2.48a5.92 5.92 0 1 0 11.84 0 5.92 5.92 0 0 0-8.48-5.34l-3.61-3.61 8.77-1.97 23.58 23.58 4.46-1.2L29.32 10.1l-13.39 3L8.83 6 6.01 8.83l7.11 7.11-2.52 11.21c-.3 1.34.11 2.74 1.08 3.7l26.4 26.4 14.74-14.74-1.2-4.46L38.08 51.6ZM21.65 24.48l2.08 2.08 4.46-1.19-3.74-3.74a3.926 3.926 0 0 1 4.93 3.79c0 2.16-1.76 3.92-3.92 3.92s-3.92-1.76-3.92-3.92c0-.34.04-.65.11-.94Z"
        }
      )
    ]
  }
);
export {
  t as Price
};
